/**
 * `dashboard_connection_loss_modal`, in a module because the two guards that read
 * it — chunk recovery and keep-alive — run outside React.
 */

let isEnabled = false;

export const connectionLossFeature = {
    setEnabled(value: boolean): void {
        isEnabled = value;
    },

    isEnabled(): boolean {
        return isEnabled;
    },
};
